import WorkpayLogoSvg from '@assets/icons/workpayLogo.svg';
import SwitchClientIcon from '@assets/icons/SwitchClientIcon';
import Button from '@components/ui/Button/Button';
import { useTranslation } from '@/hooks/useTranslation';
import styles from './EntityBlockPage.module.scss';

interface Props {
  entityName: string;
  entityUrl: string;
}

export function EntityBlockPage({ entityName, entityUrl }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <img src={WorkpayLogoSvg} alt="WorkPay" className={styles.headerLogo} />
      </header>
      <div className={styles.body}>
        <div className={styles.card}>
          <div className={styles.iconWrap}>
            <SwitchClientIcon />
          </div>
          <h1 className={styles.title}>
            {t('K_ENTITY_BLOCK_SWITCHED_TO', 'You are switched to {name}').replace('{name}', entityName)}
          </h1>
          <p className={styles.subtitle}>
            {t('K_ENTITY_BLOCK_REDIRECT_HINT', 'Click the button below to continue to the client portal.')}
          </p>
          <div className={styles.actions}>
            <Button variant="filled" fullWidth onClick={() => { window.location.href = entityUrl; }}>
              {t('K_BUTTON_REDIRECT_TO_CLIENT', 'Redirect to Client')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
